import { Box, Container, Typography } from '@mui/material';
import { PatientsManagement } from 'components/templates';
import React from 'react';

export const ArchivedPatients = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'left' }}>
          Archived Patients
        </Typography>
      </Box>
      <PatientsManagement archived={true} />
    </Container>
  );
};
